import { Box, Stack } from "@mui/material";
import { FC, useState } from "react";
import SelectInput from "../UIElements/select";
import { LoadingButton } from "@mui/lab";
import { medicType } from "./data";

export const FilterMedicInputs: FC<{
  loading: boolean;
  setFilterData: React.Dispatch<React.SetStateAction<string>>;
}> = ({ setFilterData, loading }) => {
  const [filters, setFilters] = useState({
    medic_type: "",
    verification: "",
    status: "",
  });
  const handleFilterClicked = () => {
    setFilterData(
      `filter[medic_type]=${filters.medic_type}&filter[verification]=${filters.verification}`
    );
  };
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", my: 2, gap: 2, px: 2 }}>
      <Stack sx={{ width: 200 }}>
        <SelectInput
          label={"Medic type"}
          value={filters?.medic_type}
          onChange={(e) =>
            setFilters((prev) => ({
              ...prev,
              medic_type: e.target.value,
            }))
          }
          options={medicType}
        />
      </Stack>
      <Stack sx={{ width: 200 }}>
        <SelectInput
          label={"Verification"}
          value={filters?.verification}
          onChange={(e) =>
            setFilters((prev) => ({
              ...prev,
              verification: e.target.value,
            }))
          }
          options={[
            { value: "", label: "None" },
            { value: "vetted", label: "Vetted" },
            { value: "unvetted", label: "Unvetted" },
          ]}
        />
      </Stack>
      {/* <Stack sx={{ width: 200 }}>
        <SelectInput
          label={"Status"}
          value={filters?.verification}
          onChange={(e) =>
            setFilters((prev) => ({
              ...prev,
              verification: e.target.value,
            }))
          }
          options={[
            { value: "", label: "None" },
            { value: "active", label: "Active" },
          ]}
        />
      </Stack> */}
      {/* <Stack sx={{ width: 200 }}>
        <SelectInput
          label={"Status"}
          value={""}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, status: e.target.value }))
          }
          options={[
            { value: "draft", label: "Draft" },
            { value: "pending", label: "Pending" },
            { value: "closed", label: "Closed" },
          ]}
        />
      </Stack> */}
      <Stack
        sx={{ width: 150, mx: 3 }}
        direction={"row"}
        alignItems={"flex-end"}
      >
        <LoadingButton
          onClick={handleFilterClicked}
          loading={loading}
          variant="contained"
          sx={{ my: 3, width: 80 }}
        >
          Filter
        </LoadingButton>
      </Stack>
    </Box>
  );
};
